module.exports = __webpack_public_path__ + "static/media/approved3x.a7bdd62a.png";